import React from 'react';

import _assignWith from 'lodash/assignWith';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { DEFAULT_API_URL } from './BuildConstants';
import { initialise as initialiseLogger } from './core/services/loggerService';
import * as Data from './weborder/Data';
import Weborder from './weborder/index';
import { storage } from './weborder/services/storageServices';
import * as Store from './weborder/Store';
import { getWLID, Utilities } from './weborder/Utilities';

function cleanupDeprecated(): void {
  const deprecatedStorageKeyTester = [
    // disable-local-storage-flipdish-delivery-options : whats the point of storing it when we always request it
    /flipdish-delivery-options/,
    // disable-local-storage-flipdish-restaurant-details : whats the point of storing it when we always request it
    /flipdish-restaurant-details/,
    // disable-local-storage-overflow : json responses r cashed by browser by default
    /\.json$/,
  ];

  const localStorageKeys = storage.getKeys();
  localStorageKeys.forEach((key) => {
    if (deprecatedStorageKeyTester.some((tester) => tester.test(key))) {
      storage.removeItem(key);
    }
  });
}

function initialiseWhitelabel() {
  return _assignWith(
    // lowest priority
    {
      baseHref: '/',
      fullScreenOnMobile: 'true',
      includePhysicalRestaurantIds: '',
      initialRoute: false,
      initialScreen: 'delivery-type',
      offset: '0',
      restaurant: 'system-test-wl',
      server: DEFAULT_API_URL,
      theme: 'light',
    },

    {
      baseHref: Utilities.extraOption('data-base-href'),
      fullScreenOnMobile: Utilities.extraOption('data-full-screen-on-mobile'),
      includePhysicalRestaurantIds: Utilities.extraOption('data-store-ids'),
      initialScreen: Utilities.extraOption('data-initial-screen'),
      offset: Utilities.extraOption('data-offset'),
      restaurant: getWLID(),
      server: Utilities.extraOption('data-local-server'),
      theme: Utilities.extraOption('data-theme'),
    },

    // customizer
    (objValue: any, srcValue: any) => (!srcValue ? objValue : srcValue),
  );
}

function createWebOrderStore(settings, initialState = false) {
  const storeSettings: Data.Config = {
    DeviceId: Utilities.DeviceId(),
    IncludePhysicalRestaurantIds: settings.includePhysicalRestaurantIds,
    showRestaurantList: settings.initialScreen === 'delivery-type',
  };
  const { store } = Store.Init(storeSettings, initialState);
  return store;
}

initialiseLogger();

cleanupDeprecated();

const settings = initialiseWhitelabel();
const store = createWebOrderStore(settings);

if (Utilities.flipdiv) {
  Utilities.flipdiv.classList.add('notranslate');

  render(
    <Provider store={store}>
      <Weborder settings={settings} />
    </Provider>,
    Utilities.flipdiv,
  );
}

// This exists so client restaurants could control the render of WebOrder. By
// omitting the 'flipdiv' from the HTML page, the client can control the render
// process by programmatically adding the div and then calling `renderFlipdiv`.
// The script had been loaded on page load, just not rendered due to no 'flipdiv'.

(window as any).renderFlipdiv = () => {
  if (Utilities.flipdiv) {
    render(
      <Provider store={store}>
        <Weborder settings={settings} />
      </Provider>,
      Utilities.flipdiv,
    );
  }
};
